module.exports = __webpack_public_path__ + "img/voice.3b619aab.svg";